<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Tahsilat Edilecek Faturalar</h3>
      </div>
      <b-row>
        <b-col cols="12">
          <b-row align-h="start">
            <b-col cols="12" md="auto" style="padding: 0"><vs-button type="gradient" color="success" size="small"
                style="border-radius: 5px" @click="tahsilatGenelCek('')">Sıralı Vadelerden Kapat</vs-button>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"><vs-button type="gradient" color="danger" size="small"
                style="border-radius: 5px" @click="tahsilatGenelCek('filtre')">Önce Peşin Faturalardan Kapat</vs-button>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0">
              <vs-button type="gradient" color="primary" size="small" style="border-radius: 5px"
                @click="tahsilatGenelCek('vadeli')">Önce vadeli faturalardan Kapat</vs-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="10" style="padding: 0">
          <!--
          <ag-grid-vue
            style="width: 100%; height: 500px; margin-top: 10px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="tahsilatcolumns"
            :rowData="tahsilatListesi"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
            :rowClassRules="rowClassRules"
            :doesExternalFilterPass="doesExternalFilterPass"
          >
          </ag-grid-vue>
        -->
          <vue-good-table style="font-size: small" :columns="tahsilatListesiCol" :rows="tahsilatListesi" :rtl="dir"
            :row-style-class="rowStyleClassFn2">
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field === 'DUEDATE'">
                {{ parseDate(props.row.DUEDATE) }}
              </div>
              <div v-else-if="props.column.field === 'TRANSDATE'">
                {{ parseDate(props.row.TRANSDATE) }}
              </div>
              <div v-else-if="props.column.field === 'FaturaTutar'" style="text-align: right">
                {{ currencyFormatter(props.row.FaturaTutar, "₺") }}
              </div>
              <div v-else-if="props.column.field === 'TUTAR'" style="text-align: right">
                {{ currencyFormatter(props.row.TUTAR, "₺") }}
              </div>
            </template>
          </vue-good-table>
        </b-col>
        <b-col cols="2" style="padding: 0">
          <vue-good-table :columns="kapatilanCol" :rows="BAKList" :rtl="dir" :row-style-class="rowStyleClassFn">
          </vue-good-table>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col lg="5">
          <vs-table stripe :data="tahsilatAylik">
            <template slot="thead">
              <vs-th sort-key="BYIL">Fatura Yıl</vs-th>
              <vs-th sort-key="BAY">Fatura Ay</vs-th>
              <vs-th sort-key="BYIL">Yıl</vs-th>
              <vs-th sort-key="AY">Ödenecek Ay</vs-th>
              <vs-th sort-key="TUTAR">Tutar</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].BYIL">
                  {{ data[indextr].BYIL }}
                </vs-td>
                <vs-td :data="data[indextr].BAY">
                  {{ data[indextr].BAY }}
                </vs-td>
                <vs-td :data="data[indextr].YIL">
                  {{ data[indextr].YIL }}
                </vs-td>

                <vs-td :data="data[indextr].AY">
                  {{ data[indextr].AY }}
                </vs-td>

                <vs-td :data="data[indextr].TUTAR" style="text-align: end">
                  {{ currencyFormatter(data[indextr].TUTAR, "₺") }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </b-col>
        <b-col lg="7">
          <!--
          <b-row>
            <b-form-datepicker
              v-if="tahsilatTarihiValidate == false"
              v-model="tahsilatTarihi"
              :placeholder="getNow()"
              size="sm"
              right
              local="en"
              class="mb-2"
              today-variant="danger"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
            <b-form-datepicker
              v-else
              disabled
              :placeholder="tahsilatTarihi"
              size="sm"
              right
              local="en"
              class="mb-2"
              today-variant="danger"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-row>-->
          <div>
            <div class="demo-inline-spacing">
              <b-form ref="form" @submit.prevent="repeateAgain">
                <b-row>
                  <b-col cols="12">
                    <ButtonPrimary :size="size" :title="title" :icon="repeateicon" @test-click="repeateAgain" />
                  </b-col>
                  <b-col cols="12"> </b-col>

                  <b-col cols="12">
                    <b-row>
                      <b-col cols="3">
                        <p style="text-align: center">İşlem</p>
                      </b-col>
                      <b-col cols="3">
                        <b-row>
                          <b-col cols="6">
                            <p style="text-align: center">Banka</p>
                          </b-col>
                          <b-col cols="6">
                            <p style="text-align: center">Çek No</p>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col cols="2">
                        <p style="text-align: center">Vade</p>
                      </b-col>
                      <b-col cols="1">
                        <p style="text-align: center">Gün</p>
                      </b-col>
                      <b-col cols="2">
                        <p style="text-align: center">Tutar</p>
                      </b-col>

                      <b-col cols="1"> </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12">
                    <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
                      <!-- Item Name -->
                      <b-col cols="3" style="padding-right: 0" v-if="item.disable == false">
                        <v-select v-model="item.islemselected" id="selected" placeholder="İşlem" label="title"
                          :options="islemOptions" />
                      </b-col>
                      <b-col cols="3" style="padding-right: 0" v-else>
                        <v-select :disabled="true" v-model="item.islemselected" id="selected" placeholder="İşlem"
                          label="title" :options="islemOptions" />
                      </b-col>
                      <b-col cols="3" style="padding-right: 0">
                        <b-row>
                          <!-- Cost -->
                          <b-col cols="6" style="padding-right: 0" v-if="item.disable == false">
                            <b-form-group label-for="cost">
                              <b-form-input v-model="item.bankaText" style="font-size: inherit" id="cost" type="text"
                                placeholder="Banka" />
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" style="padding-right: 0" v-else>
                            <b-form-group label-for="cost">
                              <b-form-input :disabled="true" v-model="item.bankaText" style="font-size: inherit"
                                id="cost" type="text" placeholder="Banka" />
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.disable == false">
                            <b-form-group label-for="quantity">
                              <b-form-input v-model="item.CekNo" style="font-size: inherit" id="quantity" type="text"
                                placeholder="Çek No" />
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-else>
                            <b-form-group label-for="quantity">
                              <b-form-input :disabled="true" v-model="item.CekNo" style="font-size: inherit"
                                id="quantity" type="text" placeholder="Çek No" />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>

                      <!-- Quantity -->

                      <b-col cols="2" style="padding-right: 0" v-if="item.disable == false">
                        <datepicker v-model="item.vade" :placseholder="getNow()" size="m" right local="tr-TR"
                          :format="format" class="mb-2" today-variant="danger" :language="language"
                          :monday-first="true"></datepicker>
                      </b-col>
                      <b-col cols="2" style="padding-right: 0" v-else>
                        <datepicker v-model="item.vade" :disabled="true" :format="format" :placeholder="getNow()"
                          size="sm" :language="language" :monday-first="true"></datepicker>
                      </b-col>
                      <b-col cols="1" style="padding-right: 0">
                        <b-form-group label-for="quantity">
                          <b-form-input :disabled="true" v-model="item.gun" style="font-size: inherit" id="quantity"
                            type="text" placeholder="Gün" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2" style="padding-right: 0" v-if="item.disable == false">
                        <b-form-group label-for="price">
                          <b-form-input v-model="item.tutar" style="font-size: inherit" id="quantity" type="text"
                            placeholder="Tutar" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2" style="padding-right: 0" v-else>
                        <b-form-group label-for="price">
                          <b-form-input :disabled="true" v-model="item.tutar" style="font-size: inherit" id="quantity"
                            type="text" placeholder="Tutar" />
                        </b-form-group>
                      </b-col>

                      <b-col style="padding-right: 0" cols="1" class="mb-50">
                        <b-row style="padding: 0">
                          <b-col style="padding: 0" v-if="item.disable == false && !item.isUpdate">
                            <feather-icon icon="CheckIcon" class="cursor-pointer" svgClasses="w-7 h-7"
                              style="color: green" @click="addItem(index)" />
                          </b-col>
                          <b-col style="padding: 0" v-else>
                            <feather-icon icon="EditIcon" class="cursor-pointer" svgClasses="w-7 h-7"
                              v-if="!item.isUpdate" style="color: orange" @click="updateItem(index)" />
                            <feather-icon icon="EditIcon" class="cursor-pointer" svgClasses="w-7 h-7" v-else
                              style="color: green" @click="updateItemBtn(index)" />
                          </b-col>
                          <b-col style="padding: 0" v-if="kaydetValidate == false">
                            <feather-icon @click="removeItem(index)" icon="TrashIcon" class="cursor-pointer"
                              svgClasses="w-6 h-6" style="color: red" />
                          </b-col>
                          <b-col style="padding: 0" v-else>
                            <b-button style="padding: 0" variant="flat-success" class="btn-icon rounded-circle"
                              disabled>
                              <feather-icon icon="TrashIcon" />
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-col>

                      <!-- Remove Button -->

                      <b-col cols="12" style="height: 5px"> </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Row Loop -->
              </b-form>
            </div>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row style="margin-top: 25px">
        <b-col lg="6" sm="12">
          <vs-card>
            <div slot="header">
              <b-row style="margin-bottom: 50px">
                <b-col cols="6" style="padding-right: 0">
                  <b-list-group>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px">Toplam Tahsil Edilecek Tutar</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Borç Vadesi </span>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Fark Tutar</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Kalan Vade</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Kapatılan Borcun Vadesi</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col cols="6" style="padding-left: 0">
                  <b-list-group>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px">{{
                        currencyFormatter(listToplamTutar, "₺")
                      }}</span>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{ ortalamaVadeGunYadir }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{
                        currencyFormatter(farkTutar, "₺")
                      }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{ kalanVade }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{ kapatilanBorcunVadesi }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </div>
          </vs-card>
        </b-col>
        <b-col lg="6" sm="12">
          <vs-card>
            <div slot="header">
              <b-row style="margin-bottom: 50px">
                <b-col cols="6" style="padding-right: 0">
                  <b-list-group>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span class="mr-1"> </span>
                      <span style="font-size: 17px">Tahsilat Toplamı</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Tahsilat Vadesi </span>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px"> Vade Fark Gün</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col cols="6" style="padding-left: 0">
                  <b-list-group>
                    <b-list-group-item class="d-flex" style="height: 40px" variant="warning">
                      <span style="font-size: 17px">{{
                        currencyFormatter(toplamTutar, "₺")
                      }}</span>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{
                        ortalamaKapatilanGunYazdir
                      }}</span>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex" style="height: 40px">
                      <span style="font-size: 17px">{{
                        currencyFormatter(vadeFarkGun, "")
                      }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button v-if="kaydetValidate == false" style="background-color: #0d6efd !important" type="gradient"
                  color="success" icon="save" @click="tahsilatKaydet()">Kaydet</vs-button>
                <vs-button v-else disabled style="background-color: #0d6efd !important" type="gradient" color="success"
                  icon="save">Kaydet</vs-button>
                <vs-button v-if="resimValidate == false" type="gradient" color="primary" icon="mail"
                  disabled>Mail</vs-button>
                <vs-button v-else type="gradient" color="primary" icon="mail" @click="mailGonder()">Mail</vs-button>
                <vs-button type="gradient" color="danger" icon="print" @click="yazdir()">Yazdır</vs-button>
                <vs-button v-if="resimValidate == false" disabled type="gradient" color="warning" icon="image">Ekle
                </vs-button>
                <vs-button v-else type="gradient" color="warning" icon="image" @click="resimBtn()">Ekle</vs-button>
              </vs-row>
            </div>
          </vs-card>
        </b-col>
      </b-row>
      <b-row>
        <div>
          <b-badge style="float: left; width: 20%" :key="index" v-for="(item, index) in resimListesi">
            <vs-card>
              <b-row>
                <feather-icon icon="XIcon" class="cursor-pointer" svgClasses="w-8 h-8" style="color: red"
                  @click="dosyaSil('warning', item)" />
              </b-row>
              <p>{{ bindimage + item.DOCUMENTPATH }}</p>
              <img style="width: 100%" v-bind:src="bindimage + item.DOCUMENTPATH" class="grid-view-img px-4" />
            </vs-card>
          </b-badge>
        </div>
      </b-row>
    </vs-card>
    <vs-prompt title="Dosya Ekle" acceptText="Ekle" cancelText="Vazgeç" @accept="resimEkle" :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="2">
            <span>İşlem</span>
          </b-col>
          <b-col>
            <v-select id="selected" placeholder="İşlem" label="name" :options="resimOptions" v-model="resimSelected" />
          </b-col>
        </b-row>
        <b-row style="margin-top: 20px">
          <span>Resim Ekle</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            <input type="file" accept="image/*" @change="onFileChange" id="file-input" />
          </div>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt title="Vade Fark Gün" acceptText="Ekle" cancelText="Vazgeç" @accept="popupNeden"
      :active.sync="activePromptNeden">
      <div class="con-exemple-prompt">
        <b-row style="margin-top: 20px">
          <span>Tahsilat vadesi {{ vadeFarkGun }} gün kadar geç lütfen sebebini
            yazınız.</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            <vs-textarea v-model="textareaNeden" @input="vadeneden()" />
          </div>
        </b-row>
        <b-row>
          <vs-checkbox v-model="vadeEklensinCheck" @change="check()">SEBEP TAHSİLAT MAKBUZUNA EKLENSİN Mİ?
          </vs-checkbox>
        </b-row>
      </div>
    </vs-prompt>
    <vs-popup type="filled" pazaryer title="TAHSİLAT MAKBUZU" :active.sync="popupKartDetay">
      <div>
        <b-row>
          <vs-card>
            <b-row style="margin-top: 25px; padding: 15px">
              <b-col lg="12">
                <b-row>
                  <b-col lg="6">
                    <vs-input style="padding: 0.4rem !important; margin-top: 0; width: 400px" icon-after="true"
                      icon="email" label-placeholder="E-Mail" v-model="girilenMail" /></b-col>

                  <b-col lg="2" align-self="center">
                    <vs-button @click="mailBtnGonder()" color="primary" icon="send" type="flat"
                      id="button-with-loading-yeni" class="vs-con-loading__container"></vs-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row style="padding: 15px">
              <b-col lg="12">
                <vs-table :data="mailListesi" max-height="250px">
                  <template slot="thead">
                    <vs-th style="background-color: #e8e8fa" sort-key="EMAIL">E-Mail</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="YETKILI">Yetkili</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="MISSION">Görev</vs-th>
                    <vs-th style="background-color: #e8e8fa"></vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td style="font-size: small" :data="data[indextr].EMAIL">
                        {{ data[indextr].EMAIL }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].YETKILI">
                        {{ data[indextr].YETKILI }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].MISSION">
                        {{ data[indextr].MISSION }}
                      </vs-td>
                      <vs-td>
                        <vs-button @click="mailBtnGonder(data[indextr].EMAIL)" color="primary" icon="send"
                          type="flat"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </b-col>
            </b-row>
          </vs-card>
        </b-row>
      </div>
      <Invoice ref="invoiceRef" />
    </vs-popup>
  </div>
</template>
<script>
import "flatpickr/dist/flatpickr.css";
import {
  BFormSelect,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BAlert,
  BFormDatepicker,
  BCol,
  BListGroup,
  BListGroupItem,
  BIconArrowUpRightSquareFill,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import tr from 'vuejs-datepicker/dist/locale/translations/tr';
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import moment from "moment";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import Invoice from "./Invoice.vue";
import { Icon } from "@iconify/vue2";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";
import { uuid } from "vue-uuid";
import userJson from "../../../../../public/user.json";
export default {
  directives: {
    Ripple,
  },
  name: "TahsilatComponent",
  props: ["datepickerbaslangic", "datepickerbitis"],
  data() {
    return {
      language: tr,
      format: "dd.MM.yyyy",
      filterSt: "",
      rowClassRules: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      localeText: null,
      weekday: 1,
      vadeEklensinCheck: false,
      popupNedenValidate: false,
      farkvadeFarkGun: "",
      textareaNeden: "",
      activePromptNeden: false,
      tahsilatTarihiValidate: false,
      tahsilatTarihi: "",
      bindimage: userJson.stockImage,
      resimValidate: false,
      resimSelected: "",
      kaydetValidate: false,
      ACTID: "",
      repeateicon: "add",
      size: "small",
      title: "Ekle",
      girilenMail: "",
      popupKartDetay: false,
      vadeDate: null,
      activePrompt: false,
      tahsilatAylik: [],
      kapatilan: "",
      tamamlananList: [],
      selected: null,
      toplamTutar: 0.0,
      hesapToplam: 0.0,
      listToplamTutar: 0.0,
      BAK: "",
      BAKList: [],
      BAKArray: [],
      tahsilEdilecek: "",
      htahsilatVadesi: "",
      resimOptions: [],
      islemOptions: ["Nakit", "Kredi Kartı", "Çek", "Senet", "Havale"],
      items: [
        {
          id: 1,
          islemselected: "",
          bankaText: "",
          CekNo: "",
          tutar: "",
          vade: "",
          gun: "",
          disable: false,
          docId: "",
          docId2: "",
        },
      ],
      nextTodoId: 2,
      dir: false,
      itemList: [],
      tahsilatListesi: [],
      mailListesi: [],
      kapatilanCol: [
        {
          label: "Kapatılan Tutar",
          field: "name",
        },
      ],
      tahsilatListesiCol: [
        {
          label: "Belge No",
          field: "ROOTRECEIPTNO",
        },
        {
          label: "Tarih",
          field: "TRANSDATE",
        },

        {
          label: "Vade",
          field: "DUEDATE",
        },
        {
          label: "Fark Gün",
          field: "farkgun",
        },
        {
          label: "Açıklama",
          field: "DESCRIPTION",
        },
        {
          label: "Fatura Tutar",
          field: "FaturaTutar",
        },
        {
          label: "Tahsilat Tutar",
          field: "TUTAR",
        },
      ],
      mailcolumns: [
        {
          label: "Mail ",
          field: "EMAIL",
        },
        {
          label: "Görev",
          field: "MISSION",
        },
        {
          label: "Yetkili",
          field: "YETKILI",
        },
        {
          field: "action",
          label: "Mail",
          width: "25px",
        },
      ],
      ekleButonDisable: false,

      MATRAH: 0.0,
      ortVdeToplamTutar: 0.0,
      ortalamaVadeGun: 0,
      toplamListTutar: 0.0,
      ortalamaVadeGunYadir: "",
      farkGun: 0.0,
      farkTutar: 0.0,
      kapatilanBorc2: "",
      dosyaF: "",
      dosyaFName: "",
      ortalamaKapatilanGunYazdir: "",
      kapatilanBorcunVadesi: "",
      vadeFarkGun: "",
      kalanVade: "",
      resimListesi: [],
    };
  },
  components: {
    Datepicker,
    AgGridVue,
    ButtonPrimary,
    Icon,
    Invoice,
    BListGroup,
    BListGroupItem,
    BAlert,
    BFormDatepicker,
    "v-select": vSelect,
    BFormSelect,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  methods: {
    externalFilterChanged() {
      this.gridApi.onFilterChanged();
      this.isExternalFilterPresent();
    },
    isExternalFilterPresent() {
      return this.filterSt != "everyone";
    },
    pesinSatisFilter() {
      this.gridApi.onFilterChanged();
    },
    doesExternalFilterPass(node) {
      this.filterSt = "pesinSatis";
      if (node.data) {
        switch (this.filterSt) {
          case "pesinSatis":
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            function dateDiffInDays(a, b) {
              // Discard the time and time-zone information.
              const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
              const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

              return Math.floor((utc2 - utc1) / _MS_PER_DAY);
            }
            var numSickDays = dateDiffInDays(
              new Date(node.data.TRANSDATE),
              new Date(node.data.DUEDATE)
            );
            return numSickDays <= 15;
          default:
            return true;
        }
      }
      return true;
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    vadeneden() {
      this.$store.commit("account/CARI_TAHSILAT_GECVADE", this.textareaNeden);
    },
    check() {
      if (this.vadeEklensinCheck == true)
        this.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", true);
      else {
        this.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", false);
      }
    },
    popupNeden() {
      const vs = this.$vs;

      if (this.textareaNeden == "") {
        vs.notify({
          title: "Boş değer girilemez",
          text: "Lütfen bir değer girin",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        this.popupNedenValidate = true;
        this.tahsilatKaydet();
      }
    },
    resimList(gelen) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (gelen != "") {
        const args = {
          token: Store.state.tokenId,
          DOCUMENTNO: gelen,
        };

        soap.createClient(url, function (err, client) {
          client.INT_TahsilatDosyaListesi(args, function (err, result) {
            if (result.INT_TahsilatDosyaListesiResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }

            vm.veriler = JSON.parse(result.INT_TahsilatDosyaListesiResult);

            vm.resimListesi = vm.veriler;
          });
        });
      }
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;

        // vm.upload(e.target.result, file.name);
        vm.dosyaF = e.target.result;
        vm.dosyaFName = file.name;
      };
      reader.readAsDataURL(file);
    },
    resimEkle() {
      const vs = this.$vs;
      var vm = this;

      if (vm.resimSelected == "") {
        vs.notify({
          title: "Uyarı",
          text: "İşlem seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else if (vm.dosyaFName == "") {
        vs.notify({
          title: "Uyarı",
          text: "Dosya seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          token: Store.state.tokenId,
          ISLEM: vm.resimSelected.islem,
          fileName: vm.dosyaFName,
          documentId: vm.resimSelected.value,
        };

        soap.createClient(url, function (err, client) {
          client.INT_TAHSILAT_INSEKLER(args, function (err, result) {
            if (result.INT_TAHSILAT_INSEKLERResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.INT_TAHSILAT_INSEKLERResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Başarılı",
                text: "Resim kaydı başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              vm.upload(vm.resimSelected.value2);
              vm.resimList(vm.resimSelected.value2);
            } else {
              vs.notify({
                title: "Hata",
                text: "Resim kaydında hata var.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    upload(gelen) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c",
      };
      const args = {
        f: vm.dosyaF,
        stokKodu: gelen, //gelen,
        barkod: "",
        fileName: vm.dosyaFName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function (letter) {
          return letters[letter];
        }),
      };

      soap.createClient(url, function (err, client) {
        client.uploadFileTahsilat(args, function (err, result) {
          vm.resimList(gelen);
          vs.notify({
            text: vm.dosyaFName,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
            fixed: true,
          });
        });
      });
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    rowStyleClassFn2(row) {
      return row.DUEDAY <= 15 ? "color-danger" : "";
    },
    mailList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ContactList(args, function (err, result) {
          if (result.INT_Ls_Act_ContactListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_Ls_Act_ContactListResult);
          vm.mailListesi = vm.veriler;
        });
      });
    },
    validateEmail(emailgelen) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailgelen)) {
        return true;
      } else {
        return false;
      }
    },
    mailBtnGonder(mail) {
      const vs = this.$vs;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });

      if (vm.girilenMail != "") {
        if (vm.validateEmail(vm.girilenMail)) {
          if (vm.vadeEklensinCheck == true)
            vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", true);
          else {
            vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", false);
          }
          args = {
            ALICI: vm.girilenMail,
            MESAJ: vm.$refs.invoiceRef.$el.innerHTML,
            KONU: "Tahsilat bilgilendirme",
          };
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresinin doğru olduğundan emin olun.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        }
      } else if (vm.girilenMail == "") {
        vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", false);
        if (mail != "" && typeof mail != "undefined") {
          args = {
            ALICI: mail,
            MESAJ: vm.$refs.invoiceRef.$el.innerHTML,
            KONU: "Tahsilat bilgilendirme",
          };
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresi giriniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        }
      }
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.mailGonderResult);
            if (veriler.response == "Ok") {
              vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", true);

              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              setTimeout(() => {
                vm.adminMailGonder();
              }, 15000);
            }
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });

      vm.girilenMail = "";
    },
    adminMailGonder() {
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      this.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", true);

      args = {
        ALICI: "muhasebe@canergroup.com.tr",
        MESAJ: this.$refs.invoiceRef.$el.innerHTML,
        KONU: "Tahsilat bilgilendirme",
      };
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          var vm = this;
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail başarıyla gönderildi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    yazdir() {
      this.$refs.invoiceRef.yazdir(
        this.items,
        this.ortalamaKapatilanGunYazdir,
        this.kapatilanBorcunVadesi,
        this.vadeFarkGun
        // this.tahsilatTarihi
      );
    },
    mailKontrol() {
      this.$refs.invoiceRef.getYazdirList(
        this.items,
        this.ortalamaKapatilanGunYazdir,
        this.kapatilanBorcunVadesi,
        this.vadeFarkGun
        // this.tahsilatTarihi
      );
    },
    mailGonder() {
      this.popupKartDetay = true;

      this.$refs.invoiceRef.getList(
        this.items,
        this.ortalamaKapatilanGunYazdir,
        this.kapatilanBorcunVadesi,
        this.vadeFarkGun
        // this.tahsilatTarihi
      );
      this.mailList();
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    resimBtn() {
      this.activePrompt = true;
      this.resimOptions = [];
      if (this.items.length > 0) {
        this.items.forEach((val, ind) => {
          var cektxt = val.CekNo;
          if (typeof val.CekNo == "undefined") {
            cektxt = "";
          }
          if (val.disable == true) {
            this.resimOptions.push({
              name: val.islemselected + ">" + cektxt + ">" + val.docId,
              value: val.docId,
              value2: val.docId2,
              islem: val.islemselected,
            });
          }
        });
      }
    },

    tahsilatKaydet() {
      const vs = this.$vs;
      //yyyyMMddhhmm
      var sepetek = [];
      var kontrolTahKayit = false;

      this.items.forEach((val, index) => {
        if (val.disable == false) {
          kontrolTahKayit = true;
        } else {
          sepetek.push({
            disable: val.disable,
            vade: val.vade,
            bankaText: val.bankaText,
            CekNo: val.CekNo,
            islemselected: val.islemselected,
            tutar: val.tutar,
            ind: index,
            ACTID: this.ACTID,
          });
        }
      });
console.log(this.popupNedenValidate)
console.log(parseInt(this.vadeFarkGun))
      if (kontrolTahKayit == true) {
        vs.notify({
          title: "Tahsilat",
          text: "Kaydedilmemiş alan bulunuyor. Kayıt yaptığınızdan emin olun",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else if (parseInt(this.vadeFarkGun) > 15 && this.popupNedenValidate == false) {
        this.activePromptNeden = true;
        this.farkvadeFarkGun = parseInt(this.vadeFarkGun) - 15;
      } else {
        this.tahsilatKaydiYap(sepetek, 0);
      }
    },
    tahsilatKaydiYap(sepetek, index) {
      const vs = this.$vs;

      if (sepetek.length != index) {
        var vm = this;
        var desc = "";
        const soap = require("soap");
        const url = state.sistemAddress;
        const today = new Date();
        var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");
        /*  if (vm.tahsilatTarihi != "")
          TRANSDATE = moment(String(vm.tahsilatTarihi)).format("DD.MM.YYYY");*/

        var hdfRECEIPTNO = vm.ACTID + "-" + moment(String(today)).format("MMDDhhmm");
        var hdfRECEIPTNO2 = moment(String(today)).format("MMDDhhmm");

        if (sepetek[index].disable == true) {
          var formatli = new Date(Date.parse(sepetek[index].vade));
          var formatli2 = new Date(Date.parse(today));
          const _MS_PER_DAY = 1000 * 60 * 60 * 24;
          function dateDiffInDays(a, b) {
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
          }
          // test it
          const a = new Date(formatli2),
            b = new Date(formatli),
            difference = dateDiffInDays(a, b);

          var vadeFormat = moment(String(sepetek[index].vade)).format("DD.MM.YYYY");
          var banktxt = "";
          var cektxt = "";

          if (typeof sepetek[index].bankaText == "undefined") {
            banktxt = "";
          } else {
            banktxt = sepetek[index].bankaText;
          }
          if (typeof sepetek[index].CekNo == "undefined") {
            cektxt = "";
          } else {
            cektxt = sepetek[index].CekNo;
          }
          if (sepetek[index].islemselected == "Havale") {
            desc = "Gelen Havale";
          } else if (sepetek[index].islemselected == "Nakit") desc = "Nakit Alınan";
          else {
            desc = "Crm Tahsilat";
          }
          const args = {
            token: Store.state.tokenId,
            ISLEM: sepetek[index].islemselected,
            ACTID: sepetek[index].ACTID,
            PERSONELADI: Store.state.USERLONGNAME,
            EMPLOYEEID: Store.state.employeeid,
            INSERTUSERID: Store.state.UserId,

            TRANSDATE: TRANSDATE,
            DESCRIPTION: desc,

            TOTAL: sepetek[index].tutar,
            CSNO: cektxt,
            DUEDATE: vadeFormat,
            DUEDAY: difference,
            NAMEENDORSE: "",
            BANKNAME: banktxt,
            BANKBILLNO: "",
            ITEMID: hdfRECEIPTNO + sepetek[index].ind,
            ITEM: sepetek[index].ind + 1,
            RECEIPTNO: hdfRECEIPTNO + "-" + sepetek[index].ind, //uuid.v4(),
          };

          soap.createClient(url, function (err, client) {
            client.INT_TAHSILAT_INS(args, function (err, result) {
              if (result.INT_TAHSILAT_INSResult == "-1") {
                Store.dispatch("logout");
              }
              try {
                vm.veriler = JSON.parse(result.INT_TAHSILAT_INSResult);
                if (vm.veriler.response == "Ok") {
                  vm.items[index].docId = hdfRECEIPTNO + "-" + index;
                  vm.items[index].docId2 = hdfRECEIPTNO;
                  vm.kaydetValidate = true;
                  vm.resimValidate = true;
                  index++;
                  vs.notify({
                    title: "Tahsilat",
                    text: "Tahsilat başarılı.",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  vm.tahsilatKaydiYap(sepetek, index);
                } else {
                  console.log("no");
                }
              } catch (error) {
                console.log("noooo");

                console.log(error);
                console.log(result);
              }
            });
          });
        }
      } else {
        /*
      if (sepetek.length != index) {
        this.$store
          .dispatch("account/TAHSILAT_KAYDET", sepetek[index])
          .then((response) => {
            if (response == "Ok") {
              this.kaydetValidate = true;
              
              index++;

              vs.notify({
                title: "Tahsilat",
                text: "Tahsilat başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.tahsilatKaydiYap(sepetek, index);
            }
          });
      }*/
        this.borcAylikKayitYap(0);
        return "donus ok";
      }
    },
    borcAylikKayitYap(index) {
      const today = new Date();
      //yyyyMMddhhmm
      var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");
      /*
      if (this.tahsilatTarihi != "")
        TRANSDATE = moment(String(this.tahsilatTarihi)).format("DD.MM.YYYY");*/
      var hdfRECEIPTNO = this.ACTID + "-" + moment(String(today)).format("yyyyMMDDhhmm"); //ITEMID
      const vs = this.$vs;

      if (this.tahsilatAylik.length != index) {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "Borç",
          ACTID: this.ACTID,
          TARIH: TRANSDATE,
          PERSONEL: Store.state.USERLONGNAME,
          BYIL: this.tahsilatAylik[index].YIL,
          BAY: this.tahsilatAylik[index].AY,
          BTUTAR: this.tahsilatAylik[index].TUTAR,
          TTUR: "",
          TBANKA: "",
          TCEKNO: "",
          TVADE: "",
          TTUTAR: "",
          TGUN: "",
          EVRAKNO: hdfRECEIPTNO + index,
          BORCTOPLAM: "",
          BORCVADE: "",
          ALACAKTOPLAM: "",
          ALACAKVADE: "",
          FAY: this.tahsilatAylik[index].BAY,
          FYIL: this.tahsilatAylik[index].BYIL,
          ACIKLAMA: "",
        };

        const soap = require("soap");
        const url = state.sistemAddress;
        var vm = this;

        soap.createClient(url, function (err, client) {
          client.INT_TAHSILAT_INSCARIFT(args, function (err, result) {
            if (result.INT_TAHSILAT_INSCARIFTResult == "-1") {
              Store.dispatch("logout");
            }
            index++;
            vm.borcAylikKayitYap(index);
            try {
              vm.veriler = JSON.parse(result.INT_TAHSILAT_INSCARIFTResult);
            } catch (error) {
              console.log(result);
            }
          });
        });
      } else {
        this.tahsilatAylikKayitYap(0);
        return "ok";
      }
    },
    tahsilatAylikKayitYap(index) {
      const today = new Date();
      //yyyyMMddhhmm
      var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");
      /*
      if (this.tahsilatTarihi != "")
        TRANSDATE = moment(String(this.tahsilatTarihi)).format("DD.MM.YYYY");*/
      var hdfRECEIPTNO = this.ACTID + "-" + moment(String(today)).format("yyyyMMDDhhmm"); //ITEMID
      const vs = this.$vs;
      if (this.items.length != index) {
        if (this.items[index].disable == true) {
          var banktxt = "";
          var cektxt = "";

          if (typeof this.items[index].bankaText == "undefined") {
            banktxt = "";
          } else {
            banktxt = this.items[index].bankaText;
          }
          if (typeof this.items[index].CekNo == "undefined") {
            cektxt = "";
          } else {
            cektxt = this.items[index].CekNo;
          }

          const args = {
            token: Store.state.tokenId,
            ISLEM: "Tahsilat",
            ACTID: this.ACTID,
            TARIH: TRANSDATE,
            PERSONEL: Store.state.USERLONGNAME,
            BYIL: "",
            BAY: "",
            BTUTAR: "",

            TTUR: this.items[index].islemselected,
            TBANKA: banktxt,
            TCEKNO: cektxt,
            TVADE: this.items[index].vade,
            TTUTAR: this.items[index].tutar,
            TGUN: this.items[index].gun,

            EVRAKNO: hdfRECEIPTNO + index,
            BORCTOPLAM: "",
            BORCVADE: "",
            ALACAKTOPLAM: "",
            ALACAKVADE: "",
            FAY: "",
            FYIL: "",
            ACIKLAMA: "",
          };

          const soap = require("soap");
          const url = state.sistemAddress;
          var vm = this;

          soap.createClient(url, function (err, client) {
            client.INT_TAHSILAT_INSCARIFT(args, function (err, result) {
              if (result.INT_TAHSILAT_INSCARIFTResult == "-1") {
                Store.dispatch("logout");
              }
              index++;
              vm.tahsilatAylikKayitYap(index);
              try {
                vm.veriler = JSON.parse(result.INT_TAHSILAT_INSCARIFTResult);
              } catch (error) {
                console.log(result);
              }
            });
          });
        }
      } else {
        this.genelKayitOzet();
        return "ok";
      }
    },

    genelKayitOzet() {
      const today = new Date();
      //yyyyMMddhhmm
      var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");
      /*
      if (this.tahsilatTarihi != "")
        TRANSDATE = moment(String(this.tahsilatTarihi)).format("DD.MM.YYYY");*/
      var hdfRECEIPTNO = this.ACTID + "-" + moment(String(today)).format("yyyyMMDDhhmm"); //ITEMID
      this.$refs.invoiceRef.evrakNoGetir(hdfRECEIPTNO);

      var borcvade = moment(String(this.tahsilEdilecek)).format("YYYY-MM-DD");
      var alacakvade = moment(String(this.htahsilatVadesi)).format("YYYY-MM-DD");
      var args = {};
      args = {
        token: Store.state.tokenId,
        ISLEM: "Özet",
        ACTID: this.ACTID,
        TARIH: TRANSDATE,
        PERSONEL: Store.state.USERLONGNAME,
        BYIL: "",
        BAY: "",
        BTUTAR: "",

        TTUR: "",
        TBANKA: "",
        TCEKNO: "",
        TVADE: "",
        TTUTAR: "",
        TGUN: "",

        EVRAKNO: hdfRECEIPTNO,
        BORCTOPLAM: this.listToplamTutar,
        BORCVADE: borcvade,
        ALACAKTOPLAM: this.toplamTutar,
        ALACAKVADE: alacakvade,
        FAY: "",
        FYIL: "",
        ACIKLAMA:
          "Kapatılan borçların vadesi " +
          this.kapatilanBorcunVadesi +
          " Aradaki Fark: " +
          this.vadeFarkGun +
          " gündür ",
      };
      if (this.textareaNeden != "") {
        args = {
          token: Store.state.tokenId,
          ISLEM: "Özet",
          ACTID: this.ACTID,
          TARIH: TRANSDATE,
          PERSONEL: Store.state.USERLONGNAME,
          BYIL: "",
          BAY: "",
          BTUTAR: "",

          TTUR: "",
          TBANKA: "",
          TCEKNO: "",
          TVADE: "",
          TTUTAR: "",
          TGUN: "",

          EVRAKNO: hdfRECEIPTNO,
          BORCTOPLAM: this.listToplamTutar,
          BORCVADE: borcvade,
          ALACAKTOPLAM: this.toplamTutar,
          ALACAKVADE: alacakvade,
          FAY: "",
          FYIL: "",
          ACIKLAMA:
            "Kapatılan borçların vadesi " +
            this.kapatilanBorcunVadesi +
            " Aradaki Fark: " +
            this.vadeFarkGun +
            " gündür. Nedeni: " +
            this.textareaNeden,
        };
      }
      const soap = require("soap");
      const url = state.sistemAddress;
      var vm = this;

      soap.createClient(url, function (err, client) {
        client.INT_TAHSILAT_INSCARIFT(args, function (err, result) {
          if (result.INT_TAHSILAT_INSCARIFTResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.mailBtnGonder(Store.state.EMAIL);
            vm.veriler = JSON.parse(result.INT_TAHSILAT_INSCARIFTResult);
            vm.$root.$emit("tahsilatOzetListesiM");
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },

    rowStyleClassFn(row) {
      var indis = row.originalIndex;
      if (this.tahsilatListesi.length != 0) {
        if (row.name == this.tahsilatListesi[indis].TUTAR) {
          return "is-green ";
        } else if (row.name == 0.0) {
          return "is-white ";
        } else if (this.tahsilatListesi[indis].TUTAR > row.name) {
          return "is-yellow ";
        }
      }
    },

    kapatilanHesapla() {
      this.BAKList = [];
      var topBakList = 0.0;
      var toplamKapatilanTutar = 0;
      var MATRAH2 = 0.0;
      var ortalamaKapatilanGun2 = 0.0;
      //typeof batch != "undefined"
      if (typeof this.items[0] == "undefined") {
        return "";
      } else {
        console.log(this.tahsilatListesi);

        this.tahsilatListesi.forEach((val, ind) => {
          if (val.TUTAR >= this.hesapToplam) {
            this.BAK = this.hesapToplam;
            this.hesapToplam = 0;
            //sarı
          } else if (val.TUTAR < this.hesapToplam) {
            this.BAK = val.TUTAR;
            this.hesapToplam = this.hesapToplam - val.TUTAR;
            //yeşil
          } else if (this.hesapToplam < 0) {
            this.BAK = 0;
          }
          if (this.BAK == 0) {
            //beyaz
          }

          this.BAKList.push({ name: this.BAK.toFixed(2) });

          this.BAKArray.push(this.BAK.toFixed(2));

          if (val.farkgun.toString().includes("-") == true)
            topBakList = this.BAKList[ind].name * 0;
          else topBakList = this.BAKList[ind].name * val.farkgun;

          MATRAH2 += topBakList;

          toplamKapatilanTutar += parseFloat(this.BAKList[ind].name);

          if (MATRAH2 == 0) ortalamaKapatilanGun2 = 0;
          else ortalamaKapatilanGun2 = parseFloat(MATRAH2 / toplamKapatilanTutar);

          var round = Math.round(ortalamaKapatilanGun2);

          function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
          }
          var date = new Date();
          this.kapatilanBorc2 = addDays(date, round);
          this.kapatilanBorcunVadesi = moment(String(this.kapatilanBorc2)).format(
            "DD.MM.YYYY"
          );
        });
      }
    },
    updateItem(index) {
      this.items[index].disable = false
      this.items[index].isUpdate = true

    },
    updateItemBtn(index) {
      this.items[index].disable = true
      this.items[index].isUpdate = false
      this.addItem(index)
    },
    addItem(index) {
      const vs = this.$vs;

      if (
        this.items[index].tutar == "" ||
        typeof this.items[index].tutar == "undefined"
      ) {
        vs.notify({
          title: "Tutar",
          text: "Tutar değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else if (
        this.items[index].vade == "" ||
        typeof this.items[index].vade == "undefined"
      ) {
        vs.notify({
          title: "Vade",
          text: "vade değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else if (
        this.items[index].islemselected == "" ||
        typeof this.items[index].islemselected == "undefined"
      ) {
        vs.notify({
          title: "İşlem",
          text: "işlem tipi giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        // this.tahsilatTarihiValidate = true;
        var today = new Date();
        /*
        if (this.tahsilatTarihi != "")
          today = moment(String(this.tahsilatTarihi)).format("YYYY-MM-DD");*/
        var vade = new Date(Date.parse(this.items[index].vade));

        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        function dateDiffInDays(a, b) {
          // Discard the time and time-zone information.
          const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
          const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
          var deger = Math.floor((utc2 - utc1) / _MS_PER_DAY);
          if (deger < 0) {
            deger = 0;
          }

          return deger;
        }

        const a = new Date(today),
          b = new Date(vade),
          difference = dateDiffInDays(a, b);
        this.items[index].gun = difference;
        this.items[index].tutar = this.items[index].tutar.replace(",", ".");
        /*
                this.itemList.push({
                  index1: index,
                  tutar: this.items[index].tutar,
                });*/ 
        this.toplamTutar = 0.0
        this.items.forEach((val, index) => {
          this.toplamTutar += parseFloat(val.tutar);
        });
        console.log(this.toplamTutar)
        this.items[index].disable = true;
        this.hesapToplam = this.toplamTutar;

        this.kapatilanDegerler(this.items);

        var banktxt = "";
        var cektxt = "";
        if (typeof this.items[index].bankaText == "undefined") {
          banktxt = "";
        } else {
          banktxt = this.items[index].bankaText;
        }
        if (typeof this.items[index].CekNo == "undefined") {
          cektxt = "";
        } else {
          cektxt = this.items[index].CekNo;
        }
        const arguman = {
          id: this.items[index].id,
          index: index,
          islemselected: this.items[index].islemselected,
          bankaText: banktxt,
          CekNo: cektxt,
          tutar: this.items[index].tutar,
          vade: this.items[index].vade,
          gun: this.items[index].gun,
          disable: true,
        };
        // this.$store.commit("account/ITEM_ITEMLIST", arguman);
        this.mailKontrol();
      }
    },
    kapatilanDegerler(items) {
      this.kapatilanHesapla();

      var vm = this;
      var topFarkGun = 0;
      var MATRAH1 = 0.0;
      var toplamKapatilanTutar = 0;
      var ortalamaKapatilanGun = 0;
      var ortalamaKapatilanGun = 0.0;

      items.forEach((val, index) => {
        if (val.disable == true) {
          topFarkGun = val.gun * val.tutar;
          MATRAH1 += topFarkGun;
          toplamKapatilanTutar += parseFloat(val.tutar);

          ortalamaKapatilanGun = parseFloat(MATRAH1 / toplamKapatilanTutar);
        }
      });
      vm.farkTutar = vm.listToplamTutar - toplamKapatilanTutar;
      var kalanVadeGun = (vm.MATRAH - MATRAH1) / vm.farkTutar;
      if (vm.farkTutar == 0) kalanVadeGun = 0;

      function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }
      var date = new Date();
      var kalanVade = addDays(date, kalanVadeGun);
      vm.kalanVade = moment(String(kalanVade)).format("DD.MM.YYYY");
      var tahsilatVadesi = addDays(date, ortalamaKapatilanGun);
      this.htahsilatVadesi = tahsilatVadesi;
      vm.ortalamaKapatilanGunYazdir = moment(String(tahsilatVadesi)).format("DD.MM.YYYY");

      var formatli = new Date(Date.parse(vm.kapatilanBorc2));
      var formatli2 = new Date(Date.parse(tahsilatVadesi));
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      function dateDiffInDays(a, b) {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      }

      const a = new Date(formatli),
        b = new Date(formatli2),
        difference = dateDiffInDays(a, b);

      vm.vadeFarkGun = difference;
      if (isNaN(parseFloat(vm.vadeFarkGun)) == true) {
        vm.vadeFarkGun = 0;
      }
    },
    repeateAgain() {
      const vs = this.$vs;
      var itemLocate = this.items[this.items.length - 1];

      if (typeof this.itemLocate == "undefined") {
        if (this.items.length == 0) {
          var eklenecekId = (this.nextTodoId += this.nextTodoId);
          this.items.push({
            id: eklenecekId,
            disable: false,
          });
        } else {
          var itemLocate1 = this.items[this.items.length - 1];
          if (itemLocate1.disable == false) {
            this.ekleButonDisable = true;
            vs.notify({
              title: "Uyarı",
              text: "Boşta alan bulunuyor. Öncelikle onu doldurunuz.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            var eklenecekId = (this.nextTodoId += this.nextTodoId);
            this.items.push({
              id: eklenecekId,
              disable: false,
            });
          }
        }
      } else {
        if (itemLocate.disable == false) {
          this.ekleButonDisable = true;
          vs.notify({
            title: "Uyarı",
            text: "Boşta alan bulunuyor. Öncelikle onu doldurunuz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        } else {
          var eklenecekId = (this.nextTodoId += this.nextTodoId);

          this.items.push({
            id: eklenecekId,
            disable: false,
          });
        }
      }
    },
    removeItem(index) {
      if (typeof this.items[index].tutar != "undefined") {
        this.toplamTutar -= parseFloat(this.items[index].tutar);
      }
      this.hesapToplam = this.toplamTutar;
      //  this.$store.commit("account/REMOVE_ITEM", this.items[index].id);
      this.items.splice(index, 1);
      this.kapatilanDegerler(this.items);
      this.mailKontrol();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    tahsilatGenelCek(filtre) {
      this.textareaNeden = "";
      this.vadeFarkGun = "";
      this.popupNedenValidate = false;
      this.tahsilatTarihiValidate = false;
      this.vadeEklensinCheck = false;
      this.kaydetValidate = false;
      this.resimValidate = false;
      this.MATRAH = 0.0;
      this.ortVdeToplamTutar = 0.0;
      this.ortalamaVadeGun = 0;
      this.toplamListTutar = 0.0;
      this.ortalamaVadeGunYadir = "";
      this.farkGun = 0.0;
      this.farkTutar = 0.0;
      this.toplamTutar = 0.0;
      this.hesapToplam = 0.0;

      this.ortalamaKapatilanGunYazdir = "";
      this.kapatilanHesapla();

      this.items = [
        {
          id: 1,
          islemselected: "",
          bankaText: "",
          CekNo: "",
          tutar: "",
          vade: "",
          gun: "",
          disable: false,
          docId: "",
          docId2: "",
        },
      ];

      var vm = this;
      var bitis, baslangic;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.datepickerbaslangic == "") {
        baslangic = vm.getLastTreeMonth();
      } else baslangic = moment(String(vm.datepickerbaslangic)).format("DD.MM.YYYY");
      if (vm.datepickerbitis == "") {
        bitis = vm.getNow();
      } else bitis = moment(String(vm.datepickerbitis)).format("DD.MM.YYYY");
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID,
        ILKTARIH: baslangic,
        TRANSTYPE: "101",
        SONTARIH: bitis,
        ayikla: filtre,
      };

      soap.createClient(url, function (err, client) {
        client.INT_TAHSILAT_TAHSILEDILECEKFATURALAR(args, function (err, result) {
          if (result.INT_TAHSILAT_TAHSILEDILECEKFATURALARResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.INT_TAHSILAT_TAHSILEDILECEKFATURALARResult);
          vm.tahsilatListesi = vm.veriler;
          console.log(vm.veriler);
          var listToplam = 0.0;

          vm.tahsilatListesi.forEach((val, ind) => {
            listToplam += val.TUTAR;

            vm.degerleriHesapla(val.farkgun, val.TUTAR);
          });
          vm.listToplamTutar = listToplam.toFixed(2);
        });
      });
    },

    degerleriHesapla(farkGune, tutar) {
      var vm = this;
      var topFarkGun = 0.0;
      topFarkGun = parseFloat(farkGune) * parseFloat(tutar);
      vm.MATRAH += parseFloat(topFarkGun);

      vm.ortVdeToplamTutar += parseFloat(tutar);
      vm.ortalamaVadeGun = parseInt(vm.MATRAH / vm.ortVdeToplamTutar);

      function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }
      var date = new Date();
      vm.tahsilEdilecek = addDays(date, vm.ortalamaVadeGun);
      vm.ortalamaVadeGunYadir = moment(String(vm.tahsilEdilecek)).format("DD.MM.YYYY");
    },

    tahsilatCek(datepickerbaslangic, datepickerbitis) {
      var vm = this;
      var bitis, baslangic;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (datepickerbaslangic == "") {
        baslangic = vm.getLastTreeMonth();
      } else baslangic = moment(String(datepickerbaslangic)).format("DD.MM.YYYY");
      if (datepickerbitis == "") {
        bitis = vm.getNow();
      } else bitis = moment(String(datepickerbitis)).format("DD.MM.YYYY");
      //ay.gün.yıl
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID,
        ILKTARIH: baslangic,
        TRANSTYPE: "101",
        SONTARIH: bitis,
      };
      soap.createClient(url, function (err, client) {
        client.INT_TAHSILAT_AYOZET(args, function (err, result) {
          if (result.INT_TAHSILAT_AYOZETResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_TAHSILAT_AYOZETResult);
          vm.tahsilatAylik = vm.veriler;
        });
      });
    },
  },

  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowClassRules = {
      "color-danger": (params) => {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        function dateDiffInDays(a, b) {
          // Discard the time and time-zone information.
          const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
          const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

          return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        }
        var numSickDays = dateDiffInDays(
          new Date(params.data.TRANSDATE),
          new Date(params.data.DUEDATE)
        );
        return numSickDays < 91;
      },
    };
    //this.resimList("12218-09090928-0");
    this.vadeFarkGun = "";
    this.popupNedenValidate = false;
    this.tahsilatTarihiValidate = false;
    this.ACTID = this.$store.state.account.ACTID;

    this.tahsilatGenelCek();
    this.kaydetValidate = false;
    this.resimValidate = false;
    window.addEventListener("resize", this.initTrHeight);
  },
  beforeMount() {
    this.tahsilatcolumns = [
      {
        headerName: "Belge No",
        field: "ROOTRECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Tarih",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "TRANSDATE",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.parseDate(params.data.TRANSDATE),
      },
      {
        headerName: "Vade",
        field: "DUEDATE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.parseDate(params.data.DUEDATE),
      },
      {
        headerName: "Fark Gün",
        field: "farkgun",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Fatura Tutar",
        field: "FaturaTutar",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.FaturaTutar, "₺"),
      },
      {
        headerName: "Tahsilat Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.TUTAR, "₺"),
      },
    ];
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}

.con-vs-dialog .vs-dialog {
  max-width: 500px;
}

.view-upload {
  z-index: 52000000000000000000000000000000000000000000000000000000;
}

.con-input-upload {
  width: 100px;
  height: 100px;
}

.con-img-upload .img-upload {
  width: 100px;
  height: 100px;
}

[dir] .vs__selected-options {
  padding: 0;
}

[dir] .b-calendar .b-calendar-grid-body .col[data-date] .btn {
  margin: 0px;
  padding: 0px;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.is-green {
  background-color: #28c76f;
}

.is-yellow {
  background-color: #ffc107;
}

.is-white {
  background-color: #ffffff;
}

.color-danger {
  background-color: #f08182 !important;
}
</style>
